import { Link } from 'react-router-dom';
import { Star, ShoppingBag } from '@phosphor-icons/react';
import { useCart } from '@/context/CartContext';
import { toast } from 'sonner';

export function ProductCard({ product }) {
  const { addToCart, loading } = useCart();

  const handleAddToCart = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const success = await addToCart(product.id);
    if (success) {
      toast.success(`${product.name} added to cart!`);
    }
  };

  const discount = product.original_price 
    ? Math.round((1 - product.price / product.original_price) * 100)
    : null;

  return (
    <Link 
      to={`/product/${product.id}`}
      className="product-card group block bg-white rounded-lg overflow-hidden"
      data-testid={`product-card-${product.id}`}
    >
      <div className="relative aspect-square overflow-hidden bg-nexa-stone">
        <img 
          src={product.images[0]}
          alt={product.name}
          className="w-full h-full object-cover image-zoom"
          loading="lazy"
        />
        {discount && (
          <span className="absolute top-3 left-3 bg-nexa-gold text-white text-xs font-semibold px-2 py-1 rounded">
            -{discount}%
          </span>
        )}
        {product.new_arrival && !discount && (
          <span className="absolute top-3 left-3 bg-nexa-charcoal text-white text-xs font-semibold px-2 py-1 rounded">
            New
          </span>
        )}
        <button
          onClick={handleAddToCart}
          disabled={loading}
          className="add-to-cart-btn absolute bottom-4 left-4 right-4 bg-nexa-charcoal text-white py-3 rounded-md text-sm font-medium flex items-center justify-center gap-2 hover:bg-nexa-charcoal/90 transition-colors"
          data-testid={`add-to-cart-${product.id}`}
        >
          <ShoppingBag size={18} />
          Add to Cart
        </button>
      </div>
      
      <div className="p-4">
        <p className="text-xs uppercase tracking-widest text-nexa-gold mb-1">
          {product.category}
        </p>
        <h3 className="font-medium text-nexa-charcoal mb-2 group-hover:text-nexa-gold transition-colors line-clamp-1">
          {product.name}
        </h3>
        
        <div className="flex items-center gap-1 mb-2">
          {[...Array(5)].map((_, i) => (
            <Star 
              key={i}
              size={14}
              weight={i < Math.floor(product.rating) ? "fill" : "regular"}
              className={i < Math.floor(product.rating) ? "text-nexa-gold" : "text-nexa-border"}
            />
          ))}
          <span className="text-xs text-muted-foreground ml-1">
            ({product.reviews_count})
          </span>
        </div>
        
        <div className="flex items-center gap-2">
          <span className="font-serif text-lg font-semibold text-nexa-charcoal">
            ${product.price.toFixed(2)}
          </span>
          {product.original_price && (
            <span className="text-sm text-muted-foreground line-through">
              ${product.original_price.toFixed(2)}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}
